import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Contact from './components/Contact';

function App() {
  return (
    <div>
      <Header />
      <Hero />
      <Services />
      <Contact />
    </div>
  );
}

export default App;
